import { render, staticRenderFns } from "./edit-potential-customers.vue?vue&type=template&id=7f91270e&scoped=true"
import script from "./edit-potential-customers.vue?vue&type=script&lang=js"
export * from "./edit-potential-customers.vue?vue&type=script&lang=js"
import style0 from "./edit-potential-customers.vue?vue&type=style&index=0&id=7f91270e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f91270e",
  null
  
)

export default component.exports